import React from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getLoggedInUser } from "../utilities/helper";
import { checkSessionExpiry } from "../utilities/localStorage";
import { ROLES } from "../utilities/roles";

export const roleBasedNavigation = (role) => {
  switch (role) {
    case ROLES.SUPER_ADMIN:
    case ROLES.FINANCE:
    case ROLES.ADMIN:
    case ROLES.ACTING_SA:
    case ROLES.TAX_REVIEWER:
    case ROLES.FINANCE_REVIEWER:
    case ROLES.MASTER_DATA_TEAM:
    case ROLES.CFO:
    case ROLES.FINANCE_REVIEWER_INTL:
      return "/app/recomm-vcc";
    case ROLES.USER:
      return "/app";
    case ROLES.OFFICER:
      return "/app/orders-list";
    case ROLES.REQUESTOR:
    case ROLES.PROCUREMENT_BUYER:
      return "/app/vendor";
    default:
      return "/login";
  }
};

export const PrivateRoute = ({ children, allowedRoles }) => {
  checkSessionExpiry();
  let location = useLocation();
  const { loading } = useSelector((state) => state.login);
  const { loggedIn, roles } = getLoggedInUser();

  if (loading) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  if (!loggedIn) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Check role authorization
  if (allowedRoles && roles && !roles.some((r) => allowedRoles.includes(r))) {
    let goTo = roleBasedNavigation(roles[0] || "");
    if (goTo === "/login") {
      goTo = "/app";
    }
    return <Navigate to={goTo} replace />;
  }

  return children;
};

export function PrivateSigninRoute({ children }) {
  let location = useLocation();
  const { loggedIn, roles } = getLoggedInUser();
  if (loggedIn) {
    let goTo = roleBasedNavigation(roles[0] || "");
    if (goTo === "/login") {
      goTo = "/app";
    }
    return <Navigate to={goTo} state={{ from: location }} />;
  }

  return children;
}
